import {
  CustomEventNames,
  GoogleAnalytics4EventNames,
} from '../../AnalyticsEventNames';
import AnalyticsEvent from './AnalyticsEvent';

class Purchase extends AnalyticsEvent {
  #createPurchaseEvent = () => {
    const { campaignCodeStore, countryStore, orderStore } = this.rootStore;

    const { currentOrder } = orderStore;
    const { analytics, customerInfo, currency, id } = currentOrder;
    const { postalcode, city } = customerInfo;
    const { activeCountry } = countryStore;
    const activeCoupon = campaignCodeStore.activeCoupon;
    const coupon =
      (activeCoupon && !activeCoupon.hasProductLimitations && activeCoupon) ||
      null;

    const orderProducts = currentOrder.products.map((product) => {
      return this.item.analyticsItemToItem(
        {
          product,
          quantity: product.quantity,
        },
        true
      );
    });

    return {
      currency,
      transaction_id: id,
      value: analytics.value,
      postal_code: postalcode,
      city,
      items: orderProducts,
      coupon,
      country: activeCountry.iso_code_2,
      tax: analytics.tax,
      shipping: analytics.shipping,
    };
  };

  #getSuccessData = () => {
    const data = this.#createPurchaseEvent();

    return {
      ecommerce: {
        ...data,
      },
    };
  };

  sendPaymentStartEvent = (currencyCode) => {
    const { checkoutStore, campaignCodeStore } = this.rootStore;
    const { order } = checkoutStore;
    const { selected_payment, selected_shipping } = order;
    const activeCoupon = campaignCodeStore.activeCoupon;
    const coupon =
      (activeCoupon && !activeCoupon.hasProductLimitations && activeCoupon) ||
      null;
    const productList = order?.productList || [];
    const value = order.productsTotal?.value || null;

    const data = {
      ecommerce: {
        coupon,
        currency: currencyCode,
        payment_type: selected_payment?.method?.name || null,
        shipping_tier: selected_shipping?.module?.name || null,
        value,
        items: productList.map((item) =>
          this.item.analyticsItemToItem(
            {
              product: item,
              quantity: item.quantity,
              activeProductId: item.id,
            },
            true
          )
        ),
      },
    };

    this.dataLayer.pushEventToDataLayer(data, CustomEventNames.payment_start);
  };

  sendPurchaseEvent = (updateDimensionCallback) => {
    const event = this.#getSuccessData();
    this.dataLayer.pushEventToDataLayer(
      event,
      GoogleAnalytics4EventNames.purchase,
      updateDimensionCallback
    );
  };
}

export default Purchase;
